/* eslint-disable func-names */

/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

/**
 * !!!!!!!!!!!!!!!!!
 * !!! IMPORTANT !!!
 * !!!!!!!!!!!!!!!!!
 * This is a modified version of the gatsby-browser of @wardpeet/gatsby-plugin-static-site
 *
 * The original version doesn't take query-params into account. This does as can be seen on line 37 and 56.
 *
 */

exports.onClientEntry = function () {
  const loader = window.___loader; // if development or no loader exists we shouldn't do anything

  if (process.env.NODE_ENV === 'development' || !loader) {
    return;
  }

  const { pagePath } = window;
  const { location } = window;

  if (
    pagePath &&
    pagePath !== location.pathname &&
    pagePath !== `${location.pathname}/`
  ) {
    const originalLoadPageSync = loader.loadPageSync;
    const originalLoadPage = loader.loadPage;

    loader.loadPageSync = function (pathToLoad) {
      const path = pathToLoad.split('?')[0];
      let pageResources; // if the path is the same as our current page we know it's not a prefetch

      if (path === location.pathname) {
        pageResources = originalLoadPageSync(pagePath);
      } else {
        pageResources = originalLoadPageSync(path);
      }

      if (pageResources.page) {
        pageResources.page.matchPath = '*';
      }

      return pageResources;
    };

    loader.loadPage = function (pathToLoad) {
      const path = pathToLoad.split('?')[0];
      let pageResources; // if the path is the same as our current page we know it's not a prefetch

      if (path === location.pathname) {
        pageResources = originalLoadPage(pagePath);
      } else {
        pageResources = originalLoadPage(path);
      }

      if (pageResources.page) {
        pageResources.page.matchPath = '*';
      }

      return pageResources;
    };
  } // disable hovering prefetching as we don't know if we can.
  loader.hovering = function () {};
}; // we also need to disable prefetching as we don't know the exact page-data path.
// TODO look at prefetch a whole html page on hover?
